/**
 * @module cercaliagl/plugins
 */

import { PLUGINS_PARAM } from './globals';
import Servers from './servers';

/**
 * @enum {string}
 */
export const PLUGINS = {
  Threebox: 'threebox',
  DeckGL: 'deckgl',
};

/**
 * @const
 * @type {Object.<string, string>}
 */
export const PLUGINS_URL = {
  threebox: `${Servers.plugins}/three-plugin.min.js`,
  deckgl: `${Servers.plugins}/deckgl-plugin.min.js`,
};

const loadedPlugins = [];

/**
 * @param {string} url Url
 * @param {string} name Name
 * @return {Promise}
 */
export function loadPlugin(url, name) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.setAttribute('src', url);
    script.async = true;
    script.onload = (e) => {
      loadedPlugins.push(name);
      resolve(e);
    };
    script.onerror = (e) => reject(e);
    document.body.appendChild(script);
  });
}

/**
 * @return {Array.<Promise>} Promises
 */
export function loadPlugins() {
  const promises = [];
  const arrPlugins = PLUGINS_PARAM ? PLUGINS_PARAM.split(',') : [];
  for (let i = 0; i < arrPlugins.length; i += 1) {
    const name = arrPlugins[i];
    const url = PLUGINS_URL[name];
    console.log(`Loading plugin ${name} -> ${url}`); // eslint-disable-line no-console
    promises.push(loadPlugin(url, name));
  }
  return promises;
}

/**
 * @private
 * @param {string} pluginName Plugin name
 * @return {boolean}
 */
export function checkPluginLoaded(pluginName) {
  return loadedPlugins.indexOf(pluginName) !== -1;
}
